/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MeetingsLivekitOralUnwindParams } from './meetingsLivekitOralUnwindParams';

/**
 * Request model for LiveKit oral exam presence-based unwind job
 */
export interface RunMeetingsLivekitOralUnwindJobRequest {
  type: 'meetings_livekit_oral_unwind';
  params: MeetingsLivekitOralUnwindParams;
  allowOverlappingJobs?: boolean;
}
